export interface Category {
  id: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20crisp%20white%20leather%20sneakers%20standing%20upright%20on%20a%20smooth%20sage%20green%20backdrop%20with%20a%20single%20soft%20directional%20light%20casting%20a%20gentle%20shadow%20editorial%20product%20photography&width=800&height=600&seq=cat-shoes-v2&orientation=landscape&nocache=true",
  },
  {
    id: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20folded%20oversized%20terracotta%20orange%20hoodie%20sweatshirt%20with%20visible%20ribbed%20cuffs%20on%20a%20warm%20clay%20toned%20studio%20backdrop%20with%20cozy%20soft%20lighting%20and%20rich%20fabric%20texture%20editorial%20product%20photography&width=800&height=600&seq=cat-hoodies-v2&orientation=landscape&nocache=true",
  },
  {
    id: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20three%20folded%20pastel%20cotton%20t-shirts%20in%20mint%20blush%20and%20cream%20arranged%20on%20a%20light%20sand%20wooden%20surface%20with%20bright%20airy%20natural%20light%20editorial%20product%20photography&width=800&height=600&seq=cat-tshirts-v2&orientation=landscape&nocache=true",
  },
  {
    id: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20classic%20dark%20denim%20trucker%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20warm%20khaki%20beige%20studio%20wall%20with%20soft%20window%20light%20and%20visible%20button%20details%20editorial%20product%20photography&width=800&height=600&seq=cat-jackets-v2&orientation=landscape&nocache=true",
  },
  {
    id: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20olive%20green%20cargo%20pants%20neatly%20folded%20with%20pockets%20visible%20on%20a%20warm%20gray%20concrete%20surface%20with%20soft%20overhead%20lighting%20and%20subtle%20fabric%20wrinkles%20editorial%20product%20photography&width=800&height=600&seq=cat-pants-v2&orientation=landscape&nocache=true",
  },
  {
    id: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20forest%20green%20baseball%20cap%20and%20a%20knitted%20charcoal%20beanie%20placed%20side%20by%20side%20on%20a%20light%20oak%20shelf%20with%20warm%20cozy%20lighting%20and%20soft%20shadows%20editorial%20product%20photography&width=800&height=600&seq=cat-headwear-v2&orientation=landscape&nocache=true",
  },
  {
    id: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20matching%20dusty%20rose%20tracksuit%20set%20of%20a%20zip%20hoodie%20and%20joggers%20laid%20flat%20together%20on%20a%20soft%20cream%20linen%20background%20with%20gentle%20natural%20light%20editorial%20product%20photography&width=800&height=600&seq=cat-sets-v2&orientation=landscape&nocache=true",
  },
  {
    id: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20small%20stack%20of%20soft%20pastel%20cotton%20underwear%20in%20white%20and%20pale%20yellow%20neatly%20folded%20on%20a%20warm%20ivory%20surface%20with%20soft%20diffused%20lighting%20and%20clean%20minimal%20styling%20editorial%20product%20photography&width=800&height=600&seq=cat-underwear-v2&orientation=landscape&nocache=true",
  },
  {
    id: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20bright%20emerald%20green%20sports%20jersey%20with%20white%20number%20details%20folded%20on%20a%20light%20neutral%20studio%20surface%20with%20crisp%20even%20lighting%20and%20vibrant%20color%20editorial%20product%20photography&width=800&height=600&seq=cat-jersey-v2&orientation=landscape&nocache=true",
  },
  {
    id: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylish%20pair%20of%20tortoiseshell%20sunglasses%20and%20a%20leather%20strap%20watch%20arranged%20on%20a%20butter%20yellow%20backdrop%20with%20bright%20fresh%20lighting%20and%20clean%20minimal%20composition%20editorial%20product%20photography&width=800&height=600&seq=cat-accessories-v2&orientation=landscape&nocache=true",
  },
  {
    id: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20structured%20camel%20brown%20leather%20tote%20bag%20with%20gold%20hardware%20standing%20on%20a%20warm%20beige%20studio%20surface%20with%20soft%20dramatic%20side%20lighting%20and%20rich%20leather%20texture%20editorial%20product%20photography&width=800&height=600&seq=cat-bags-v2&orientation=landscape&nocache=true",
  },
  {
    id: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Three%20rolled%20genuine%20leather%20belts%20in%20black%20brown%20and%20tan%20with%20visible%20metal%20buckles%20on%20a%20warm%20sand%20backdrop%20with%20soft%20even%20lighting%20and%20rich%20texture%20editorial%20product%20photography&width=800&height=600&seq=cat-belts-v2&orientation=landscape&nocache=true",
  },
  {
    id: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=An%20elegant%20amber%20glass%20perfume%20bottle%20with%20a%20gold%20cap%20on%20a%20soft%20rose%20blush%20backdrop%20with%20gentle%20reflective%20lighting%20and%20a%20subtle%20mist%20of%20fragrance%20editorial%20product%20photography&width=800&height=600&seq=cat-perfumes-v2&orientation=landscape&nocache=true",
  },
  {
    id: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20varied%20collection%20of%20assorted%20fashion%20items%20including%20a%20scarf%20wallet%20and%20keychain%20scattered%20on%20a%20soft%20gray%20beige%20surface%20with%20warm%20natural%20light%20editorial%20product%20photography&width=800&height=600&seq=cat-other-v2&orientation=landscape&nocache=true",
  },
];